export const OPEN_LEFT_DRAWER = 'OPEN_LEFT_DRAWER';
export const CLOSE_LEFT_DRAWER = 'CLOSE_LEFT_DRAWER';
export const OPEN_LEFT_DRAWER_WITH_TAB = 'OPEN_LEFT_DRAWER_WITH_TAB';
